import React from 'react';
export default class TimelineResumeEducation extends React.Component{

    getResumeBlock(data, index){
        return <div data-v-2568b4c2="" className="section-item" key={index}>
            <div data-v-2568b4c2="" className="section-metas">
                <div data-v-2568b4c2="" className="section-title">
                    <div data-v-2568b4c2=""><span data-v-2568b4c2="" className="degree-name">{data.degree}</span></div>
                    <div data-v-2568b4c2="" className="section-title-secondary"> {data.schoolName}</div>
                </div>
                <div data-v-2568b4c2="" className="section-date"><span data-v-2568b4c2="">{data.startDate} -</span><span
                    data-v-2568b4c2="">{data.endDate}</span></div>
            </div>
            <div data-v-2568b4c2="" className="section-description" dangerouslySetInnerHTML={{ __html: data.description }}></div>
        </div>
    }

    render(){
        return  <div data-v-2568b4c2="" className="section">
                    {this.props.data.map((item, index) => {
                        return this.getResumeBlock(item, index);
                    })}
                </div>

    }
}